import { jsxs, jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { forwardRef, useMemo } from "react";
import FieldHelperText from "../FieldHelperText/FieldHelperText.js";
const TextField = forwardRef(
  ({
    classes,
    className,
    icon,
    helperText,
    error,
    displayHelperText = false,
    size = "md",
    t,
    helperTextClasses,
    enableNumberDefaultBehavior = false,
    prefix,
    fieldHelperTextManager,
    ...inputProps
  }, ref) => {
    const shouldShowError = !!error && (!fieldHelperTextManager || (fieldHelperTextManager.submitCount ?? 0) > 0);
    const variant = useMemo(() => {
      if (inputProps.disabled) return "disabled";
      if (shouldShowError) return "error";
      return "normal";
    }, [shouldShowError, inputProps.disabled]);
    const { themeClasses } = useThemePresetClasses("TextField", classes, className, {
      variant,
      modifier: size
    });
    const handleFocus = (e) => {
      var _a;
      fieldHelperTextManager == null ? void 0 : fieldHelperTextManager.triggerError(String(inputProps.name));
      (_a = inputProps.onFocus) == null ? void 0 : _a.call(inputProps, e);
    };
    const handleKeyDown = (e) => {
      if (inputProps.type === "number" && !enableNumberDefaultBehavior) {
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
          e.preventDefault();
          const input = e.currentTarget;
          input.type = "text";
          if (e.key === "ArrowUp") {
            input.setSelectionRange(input.value.length, input.value.length);
          } else {
            input.setSelectionRange(0, 0);
          }
          input.type = "number";
        }
      }
    };
    return /* @__PURE__ */ jsxs("div", { className: cn("relative", themeClasses == null ? void 0 : themeClasses.root), children: [
      !!icon && /* @__PURE__ */ jsx("div", { className: cn("absolute", themeClasses == null ? void 0 : themeClasses.iconContainer), children: icon }),
      !!prefix && /* @__PURE__ */ jsx("div", { className: cn(themeClasses == null ? void 0 : themeClasses.prefixContainer), children: prefix }),
      /* @__PURE__ */ jsx(
        "input",
        {
          className: cn(themeClasses == null ? void 0 : themeClasses.input, {
            "pl-9": !!icon && size === "sm",
            "pl-12": !!icon && size === "md",
            "pl-14": !!icon && size === "lg",
            "pl-16": !!icon && size === "xl"
          }),
          onKeyDown: handleKeyDown,
          ...inputProps,
          onFocus: handleFocus,
          ref
        }
      ),
      /* @__PURE__ */ jsx(
        FieldHelperText,
        {
          error: shouldShowError,
          helperText,
          alwaysDisplay: displayHelperText,
          t,
          ...helperTextClasses
        }
      )
    ] });
  }
);
const TextField$1 = TextField;
export {
  TextField$1 as default
};
